import React from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  /** Icon to display above the title. Defaults to Inbox. */
  Icon?: LucideIcon;
  /** Short headline — one line, sentence case. */
  title: string;
  /** Optional secondary line — keep under ~120 chars. */
  description?: React.ReactNode;
  /** Optional CTA(s) — pass <button className="hf-btn …">. */
  action?: React.ReactNode;
  /** Compact variant for inline contexts (table cells, small cards). */
  compact?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  Icon = Inbox,
  title,
  description,
  action,
  compact = false
}) => (
  <div className={`hf-empty${compact ? ' hf-empty-compact' : ''}`} role="status">
    <div className="hf-empty-icon" aria-hidden="true">
      <Icon size={compact ? 22 : 28} strokeWidth={1.5} />
    </div>
    <div className="hf-empty-title">{title}</div>
    {description && <div className="hf-empty-desc">{description}</div>}
    {action && <div className="hf-empty-actions">{action}</div>}
  </div>
);
